import { CHATBOT_WIDGET_API_HOST } from './chatbotSettings';

export const createInstructorWebsiteDraft = website => ({
  showOnWebsite: !!website?.showOnWebsite,
  displayName: website?.displayName || '',
  priceLabel: website?.priceLabel || '',
  websiteDescription: website?.websiteDescription || '',
  highlightsText: Array.isArray(website?.highlights) ? website.highlights.join('\n') : '',
  sortOrder: website?.sortOrder ?? 1,
  images: Array.isArray(website?.images) ? website.images.map(image => ({ ...image, file: null, isNew: false })) : []
});

export const buildInstructorWebsitePayload = draft => {
  const displayName = String(draft.displayName || '').trim();
  const priceLabel = String(draft.priceLabel || '').trim();
  const websiteDescription = String(draft.websiteDescription || '');
  if (displayName.length > 100) throw new Error('Display name must be 100 characters or fewer.');
  if (priceLabel.length > 100) throw new Error('Price label must be 100 characters or fewer.');
  if (websiteDescription.length > 5000) throw new Error('Description must be 5000 characters or fewer.');
  const highlights = String(draft.highlightsText || '').split(/\r?\n/).map(item => item.trim()).filter(Boolean);
  if (highlights.length > 100) throw new Error('Highlights must contain at most 100 items.');
  if (highlights.some(item => item.length > 200)) throw new Error('Highlight items must be text up to 200 characters.');
  const sortOrder = Number(draft.sortOrder);
  if (!Number.isInteger(sortOrder) || sortOrder < 1 || sortOrder > 9999) throw new Error('Website order must be a whole number from 1 to 9999.');
  return { showOnWebsite: !!draft.showOnWebsite, displayName: displayName || '', priceLabel, websiteDescription, highlights, sortOrder };
};

export const appendInstructorWebsiteFields = (formData, draft) => {
  formData.append('showOnWebsite', String(!!draft.showOnWebsite));
  formData.append('displayName', draft.displayName || '');
  formData.append('priceLabel', draft.priceLabel || '');
  formData.append('websiteDescription', draft.websiteDescription || '');
  formData.append('highlights', draft.highlightsText || '');
  formData.append('sortOrder', String(draft.sortOrder));
};

const escapeAttribute = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
const instructorWidgetStyleAttributes = {
  headingFont: 'data-heading-font', headingColor: 'data-heading-color', textFont: 'data-text-font', textColor: 'data-text-color', accentColor: 'data-accent-color'
};

export const buildInstructorWidgetSnippet = ({ widgetKey, scope = 'all', instructorId, locationCode, locationIsDefault = false, overrides = {} }) => {
  if (!widgetKey) return '';
  const attributes = [`data-widget-key="${escapeAttribute(widgetKey)}"`];
  if (scope === 'instructor' && instructorId != null) attributes.push(`data-instructor-id="${escapeAttribute(instructorId)}"`);
  if (scope === 'location' && locationCode && !locationIsDefault) attributes.push(`data-location-id="${escapeAttribute(locationCode)}"`);
  Object.entries(instructorWidgetStyleAttributes).forEach(([key, attribute]) => {
    const value = String(overrides[key] ?? '').trim();
    if (value) attributes.push(`${attribute}="${escapeAttribute(value)}"`);
  });
  return `<script defer src="${CHATBOT_WIDGET_API_HOST}/instructor/widget.js" ${attributes.join(' ')}></script>`;
};